import {FC, useEffect, useState} from 'react'
import { Col, Row } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import { MultiSelect } from 'react-multi-select-component'
import { getOtorisator } from 'src/api/modules/sip'

interface Props {
    items: any[]
    reviewers: any[]
    approvers: any[]
    onChangeApprovers: (data: any[]) => void
    onChangeReviewers: (data: any[]) => void
}

export const SettingApproval: FC<Props> = ({
    items,
    reviewers,
    approvers,
    onChangeApprovers,
    onChangeReviewers
}) => {

    const {t} = useTranslation()
    const [optionApprovers, setOptionApprovers] = useState<any[]>([])

    const loadApprovers = async (items: any[]) => {
        setOptionApprovers([])
        onChangeReviewers([])
        onChangeApprovers([])

        try{
            let {data} = await getOtorisator(items)
            setOptionApprovers(data.data?.map((item: any) => {
                return {
                    label: [
                        item.nama_pengguna,
                        item.name,
                    ].join(" - "),
                    value: item.id
                }
            }))

            if(approvers.length == 0 || reviewers.length == 0) {
                const uniqueLevels = Array.from(new Set(data.data?.map((item: any) => item.level))) as number[];
                uniqueLevels.sort((a, b) => b - a);
                
                const pickedItems = uniqueLevels.map((level: number) => {
                    return data.data?.find((item: any) => item.level === level)
                });
                
                if(approvers.length == 0) {
                    onChangeApprovers([
                        {
                            label: [
                                pickedItems[0].nama_pengguna,
                                pickedItems[0].name,
                            ].join(" - "),
                            value: pickedItems[0].id
                        }
                    ]);
                }
                if(reviewers.length == 0) {
                    onChangeReviewers(pickedItems.slice(1).map((item: any) => {
                        return {
                            label: [
                                item.nama_pengguna,
                                item.name,
                            ].join(" - "),
                            value: item.id
                        }
                    }));
                }
            }

        }catch(e: any) {
            console.log(e)
        }
    }

    useEffect(() => {
        loadApprovers(items.map((item: any) => item.id))
    }, [items])

    return <div className='my-5 py-5'>
        <h3>{ t('setting-approval') }</h3>

        <Row className='my-4'>
            <Col md={5}>
                <p className='fs-4 mt-2'>{t('reviewer')} <span className='text-danger'>*</span></p>
            </Col>
            <Col md={7}>
                <MultiSelect
                    options={optionApprovers}
                    value={reviewers}
                    onChange={onChangeReviewers}
                    labelledBy='Select'
                />
            </Col>
        </Row>

        <Row className='my-4'>
            <Col md={5}>
                <p className='fs-4 mt-2'>{t('approver')} <span className='text-danger'>*</span></p>
            </Col>
            <Col md={7}>
                <MultiSelect
                    options={optionApprovers}
                    value={approvers}
                    onChange={onChangeApprovers}
                    labelledBy='Select'
                />
            </Col>
        </Row>
    </div>
}